/** Countries referenced by billing rules; other ISO country codes remain valid. */
enum BillingCountries {
  NORWAY = "NO",
  SWEDEN = "SE",
  UNITED_KINGDOM = "GB",
}

export default BillingCountries;
